/* eslint-disable react/forbid-prop-types */
import { formatCurrency } from 'components/helpers/currencyOptions';
import React from 'react';
import PropTypes from 'prop-types';

const ConvertedAmount = ({
  amount, rate, loading, targetCurrencyConfig, className,
}) => {
  if (!targetCurrencyConfig) return null;
  if (loading && !rate) {
    return (
      <span className={`converted-amount converted-amount--loading ${className}`}>
        <span className="spinner-border spinner-border-sm" />
      </span>
    );
  }
  if (!rate) return null;
  return (
    <span className={`converted-amount ${className}`}>
      <span className="converted-amount__tilde">≈</span>
      <span className="converted-amount__value">{formatCurrency(amount * Number(rate), targetCurrencyConfig)}</span>
    </span>
  );
};

ConvertedAmount.propTypes = {
  amount: PropTypes.number.isRequired,
  rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  loading: PropTypes.bool,
  targetCurrencyConfig: PropTypes.shape({
    lgCurrencyID: PropTypes.string,
    strCode: PropTypes.string,
    strDescription: PropTypes.string,
    strStatut: PropTypes.string,
    bDefault: PropTypes.bool,
    strGroupingSeparator: PropTypes.string,
    strDecimalSeparator: PropTypes.string,
    strDisplayFormat: PropTypes.string,
    bCodeAppendedEnd: PropTypes.bool,
    bAddCodeValueSeparator: PropTypes.bool,
    strCodeValueSeparator: PropTypes.string,
    intFractionsCount: PropTypes.number,
    dtCreated: PropTypes.shape({
      seconds: PropTypes.number,
      nanos: PropTypes.number,
    }),
  }),
  className: PropTypes.string,
};
ConvertedAmount.defaultProps = {
  rate: null, loading: false, targetCurrencyConfig: null, className: '',
};

export default ConvertedAmount;
